/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBinoculars,
  faGear,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { handleToolTipMouseEnter } from '../helpers/layout'
import TableSorter from './TableSorter'
import { hasUserPermission } from '../utils/permissionHelper'
import { useSelector, useDispatch } from 'react-redux'
import { selectUser } from '../redux/userSlice'
import { getActivePermissions } from '../redux/permissionSelectors'
import {
  setSelectedRows,
  selectMultiSelectedRows,
} from '../redux/multiSelectRowSlice'

export default function TableHeader(props) {
  const active = useSelector(selectUser)
  const activePermissions = getActivePermissions(active)

  let {
    columns,
    hasMultiSelect,
    hasActions,
    hasView = true,
    extraAction = [],
    startId,
    isLightColor = false,
    sortableFields,
    url,
    searchFilter,
    setPartialLoad,
    isSortLocally = false,
    module = null,
    baseName = null,
    isSubpanel = false,
    onSort = null,
    sortState = null,
  } = props
  const [sortColumnsObj, setSortColumnsObj] = useState({})
  const multiSelectedRows = useSelector(selectMultiSelectedRows)
  const dispatch = useDispatch()
  const showHelperTooltip = (toolTip) => {
    handleToolTipMouseEnter(toolTip, 'div.lox-hooktable')
  }
  const selectAllRows = (event) => {
    dispatch(setSelectedRows({ isAll: !!event.target.checked }))
  }
  let count = 0
  const renderHeader = (header, key) => {
    if (
      !hasUserPermission(activePermissions, 'show_ids') &&
      header.column_name === 'id'
    ) {
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <></>
    }
    const sortDirection =
      sortState?.column_name === header.column_name ? sortState.direction : null
    return (
      <th
        key={key}
        className={`is-selected has-text-centered ${
          isLightColor && 'has-background-light has-text-dark'
        }`}
        style={{ whiteSpace: 'nowrap', minWidth: `${header.list_size * 2}em` }}
        aria-sort={
          onSort
            ? sortDirection
              ? `${sortDirection}ending`
              : 'none'
            : undefined
        }
      >
        {header.label_name}
        {sortableFields &&
          sortableFields.length > 0 &&
          sortableFields.find((x) => x.column_name === header.column_name) && (
            <TableSorter
              url={url}
              sortColumnsObj={sortColumnsObj}
              setSortColumnsObj={setSortColumnsObj}
              field={header}
              setPartialLoad={setPartialLoad}
              searchFilter={searchFilter}
              isSortLocally={isSortLocally}
              onSort={onSort}
              sortDirection={sortDirection}
            />
          )}
        <span
          className={`${
            header.helper_text ? 'lox-no-border' : 'is-hidden'
          } lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary has-text-weight-normal`}
          data-tooltip={header.helper_text}
          onMouseEnter={showHelperTooltip}
        >
          <FontAwesomeIcon
            icon={faQuestionCircle}
            className={`pl-1 ${
              isLightColor ? 'has-text-link' : 'has-text-white'
            }`}
          />
        </span>
      </th>
    )
  }

  return (
    <thead>
      <tr className="is-selected">
        {hasMultiSelect && (
          <th
            className={`is-selected sticky ${
              !!isLightColor && 'has-background-light has-text-dark'
            }`}
            style={{ width: '35px' }}
          >
            <span
              className={`button is-ghost has-text-white is-cursor-pointer ${
                !!isLightColor && 'has-background-light has-text-dark'
              }`}
            >
              <input
                type="checkbox"
                checked={multiSelectedRows.isAll}
                onChange={selectAllRows}
              />
            </span>
          </th>
        )}
        {hasView && (
          <th
            className={`is-selected sticky has-text-centered ${
              !!isLightColor && 'has-background-light has-text-dark'
            }`}
            style={{ width: '35px' }}
          >
            <span
              className={`button is-ghost has-text-white is-not-cursor-pointer ${
                !!isLightColor && 'has-background-light has-text-dark'
              }`}
            >
              <FontAwesomeIcon icon={faBinoculars} />
            </span>
          </th>
        )}
        {extraAction.map((action) => (
          <th
            className={`is-selected sticky ${
              !!isLightColor && 'has-background-light has-text-dark'
            }`}
            style={{ width: '35px' }}
          >
            <span
              className={`button is-ghost has-text-white is-not-cursor-pointer ${
                !!isLightColor && 'has-background-light has-text-dark'
              }`}
            >
              <FontAwesomeIcon icon={action} />
            </span>
          </th>
        ))}
        {columns.map((col) => {
          count += 1
          return renderHeader(col, startId + count)
        })}
        {hasActions && (
          <th
            className={`is-selected ${
              !!isLightColor && 'has-background-light has-text-dark'
            }`}
            style={{ minWidth: '70px', whiteSpace: 'nowrap' }}
          >
            <div className="field has-text-centered">
              <p className="control">
                <button
                  type="button"
                  className={`button is-ghost has-text-white is-not-cursor-pointer ${
                    !!isLightColor && 'has-background-light has-text-dark'
                  }`}
                >
                  <FontAwesomeIcon icon={faGear} />
                </button>
              </p>
            </div>
          </th>
        )}
      </tr>
    </thead>
  )
}
